import { InjectionToken, NgModule, APP_INITIALIZER } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppConfigService } from 'src/app/services/appconfig/app-config.service';
import { JsonInterceptor } from '../interceptors/json-interceptor';
import {
  MsalGuard, MsalBroadcastService,
  MsalInterceptorConfiguration, MsalModule, MsalService,
  MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG,
  MsalGuardConfiguration,
  MsalInterceptor
} from '@azure/msal-angular';
import { BrowserCacheLocation, IPublicClientApplication, InteractionType, PublicClientApplication } from '@azure/msal-browser';
const APP_DIR = '';
export const BASE_HREF = '/';
const AUTH_CONFIG_URL_TOKEN = new InjectionToken<string>('AUTH_CONFIG_URL');
const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
let allConfig: any = null;

export function initializerFactory(config: AppConfigService, configUrl: string): any {
  // APP_INITIALIZER, accept a function return which will return a promise
  const promise = config.loadAppConfig(configUrl).then((value) => {
    allConfig = config.get();
  });
  return () => promise;
}
export function MSALInstanceFactory(): IPublicClientApplication {
  
  const redirectUri = BASE_HREF?.length > 1 ? BASE_HREF.substr(0, BASE_HREF.length - 1) : BASE_HREF; // trim off any trailing slash to match AppReg redirect URIs
  return new PublicClientApplication({
    auth: {
      clientId: allConfig.application.clientId,
      authority: allConfig.application.authority,
      redirectUri: redirectUri,
      postLogoutRedirectUri: redirectUri
    },
    
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,//LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        //loggerCallback: loggerCallback,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap
    .set(allConfig.graphEndpoint, ['openid', 'profile', allConfig.consentScope])
    .set(allConfig.apiUrl, [allConfig.application.userScope])
    ;

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: { scopes: [allConfig.consentScope] },
    //loginFailedRoute: HttpErrorCode.Unauthorized.toString() //REVISIT a distinct treatment for failed logins
  };
}

@NgModule({
  providers: [MsalModule],
  imports: []
})
export class MsalAppConfigModule {
  static forRoot(configFile: string) {
    return {
      ngModule: MsalAppConfigModule,
      providers: [
        AppConfigService,
        { provide: AUTH_CONFIG_URL_TOKEN, useValue: configFile },
        {
          provide: APP_INITIALIZER, useFactory: initializerFactory,
          deps: [AppConfigService, AUTH_CONFIG_URL_TOKEN], multi: true
        },
        {
          provide: MSAL_INSTANCE,
          useFactory: MSALInstanceFactory
        },
        {
          provide: MSAL_GUARD_CONFIG,
          useFactory: MSALGuardConfigFactory
        },
        {
          provide: MSAL_INTERCEPTOR_CONFIG,
          useFactory: MSALInterceptorConfigFactory
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: MsalInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: JsonInterceptor,
          multi: true,
        }
      ]
    };
  }
}